import { Breadcrumbs, Button, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { Admin_Parivartan_Get_All_SubCategories } from "../../../constants";
import axios from "axios";
import SubCategoryTable from "./components/SubCategoryTable";
import SubCategoryFilter from "./components/SubcategoryFilter";
import AddNewSubcategoryModal from "./components/AddNewSubcategoryModal";

const SubCategoryComponent = () => {
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [loading, setLoading] = useState(false);
  const [addNewSubcategoryModalOpen, setAddNewSubCategoryModalOpen] =
    useState(false);

  const handleBack = () => {};
  const getSubCategoryData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${Admin_Parivartan_Get_All_SubCategories}?categoryId=${selectedCategory}`
      );
      setSubCategoryList(response.data.subCategories || []);
    } catch (error) {
      console.error("Error fetching attendance data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSubCategoryData();
  }, [selectedCategory]);

  return (
    <>
      <Breadcrumbs separator="›" aria-label="breadcrumb">
        <Link
          underline="hover"
          key="1"
          color="inherit"
          to="/settings"
          onClick={handleBack}
        >
          Admin Panel
        </Link>
        <Typography key="2" color="text.primary">
          Sub-Category
        </Typography>
      </Breadcrumbs>

      <div className="p-6">
        {/* Header */}
        <div className="flex justify-between items-center mb-6">
          <div>
            <h1 className="text-2xl font-bold">Sub-Categories</h1>
          </div>
          <Button
            variant="contained"
            color="success"
            startIcon={<AddIcon />}
            sx={{ mr: 1 }}
            onClick={() => setAddNewSubCategoryModalOpen(true)}
          >
            Add New Sub-Category
          </Button>
        </div>

        <SubCategoryFilter
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
        />
        <SubCategoryTable
          subCategoryList={subCategoryList}
          loading={loading}
          setLoading={setLoading}
          onRefresh={getSubCategoryData}
        />

        <AddNewSubcategoryModal
          isOpen={addNewSubcategoryModalOpen}
          onClose={() => {
            setAddNewSubCategoryModalOpen(false);
          }}
          onRefresh={getSubCategoryData}
        />
      </div>
    </>
  );
};

export default SubCategoryComponent;
